import { AxiosPromise } from 'axios'
import client from '../../../../apis/client'
import { RemoteAction, RemoteInputOverview, RemoteRequest } from './types'

/**
 * 遠隔入力の API。共有するのは `apis/client`(送り先の形)だけで、hook と型は latest に閉じる
 * (ADR-0034)。口は prescription `remote_input/urls.py` の 4 本。
 */
export const getRemoteInputOverview = (): AxiosPromise<RemoteInputOverview> =>
  client.get('/api/remote-input/requests/')

export const patchRemoteInputRoute = (
  isOn: boolean
): AxiosPromise<{ is_on: boolean }> =>
  client.patch('/api/remote-input/route/', { is_on: isOn })

/** 紙ごとの「遠隔へ」。取り消し・お断りの後の頼み直しも同じ口 */
export const createRemoteRequest = (
  eventId: string,
  note: string
): AxiosPromise<RemoteRequest> =>
  client.post(`/api/ocr-events/${eventId}/remote-request/`, { note })

export const actOnRemoteRequest = (
  requestId: string,
  action: Exclude<RemoteAction, 'request'>,
  note: string
): AxiosPromise<RemoteRequest> =>
  client.post(`/api/remote-requests/${requestId}/${action}/`, { note })
